import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface ModulePermissionDto {
    moduleKey: string;
    isEnabled: boolean;
}

export interface Role {
    id: string;
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private http = inject(HttpClient);
    private apiUrl = `${environment.apiUrl}/roles`;

    getRoles(): Observable<Role[]> {
        return this.http.get<Role[]>(this.apiUrl);
    }

    getPermissions(roleId: string): Observable<ModulePermissionDto[]> {
        return this.http.get<ModulePermissionDto[]>(`${this.apiUrl}/${roleId}/permissions`);
    }

    getMyPermissions(): Observable<ModulePermissionDto[]> {
        return this.http.get<ModulePermissionDto[]>(`${environment.apiUrl}/auth/me/permissions`);
    }

    updatePermissions(roleId: string, permissions: ModulePermissionDto[]): Observable<void> {
        return this.http.put<void>(`${this.apiUrl}/${roleId}/permissions`, permissions);
    }
}
